// React
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

// @mui material components
import { Card, Fade, Icon, Modal, Tooltip } from "@mui/material";

// Custom UI components
import { MessageManager } from "context";
import { ConfirmarContext } from "context/ConfirmarContext";
import { gql, useLazyQuery } from "@apollo/client";
import TimelineList from "components/Timeline/TimelineList";
import TimelineItem from "components/Timeline/TimelineItem";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { formatDate } from "utils/formatters";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "90%",
  width: { xs: "90%", sm: "70%", md: "60%", xxl: "50%" },
  overflow: "auto",
  p: 3,
};

export default function ModalHistorial({ open, handleClose, pedido }) {
  const { handleSnackbar } = useContext(MessageManager);
  const [estados, setEstados] = useState([]);

  const [getEstados, { loading }] = useLazyQuery(
    gql`
      query getEstados($id: ID!) {
        pedidoCompraEstados(id: $id) {
          base {
            nombre
          }
          updatedAt
          cancelado
          canceladoMotivo
          user {
            nombre
            apellido
          }
        }
      }
    `,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        setEstados(data.pedidoCompraEstados);
      },
      onError: (error) => {
        handleSnackbar("error", error.message);
      },
    }
  );
  useEffect(() => {
    if (pedido && open) {
      getEstados({ variables: { id: pedido.id } });
    }
  }, [pedido, open]);
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" justifyContent="space-between">
            <SoftBox>
              <SoftTypography variant="h6">Historial de estados del pedido</SoftTypography>
            </SoftBox>
            <Tooltip title="Cerrar" placement="top">
              <Icon fontSize="medium" onClick={handleClose} sx={{ cursor: "pointer" }}>
                close
              </Icon>
            </Tooltip>
          </SoftBox>
          <TimelineList title="Historial del pedido">
            <SoftBox
              sx={{
                maxHeight: "250px",
                overflow: "auto",
              }}
            >
              {estados.map((estado, index) => {
                return (
                  <TimelineItem
                    key={index}
                    title={estado.base.nombre}
                    icon={estado.cancelado ? "cancel" : "check_circle"}
                    color={estado.cancelado ? "error" : "success"}
                    dateTime={
                      `${formatDate(estado.updatedAt, "dd/MM/yyyy hh:mm")} - ${estado?.user?.nombre} ${estado?.user?.apellido}`
                    }
                    description={estado.cancelado && estado.canceladoMotivo ? `Motivo: ${estado.canceladoMotivo}` : null}
                  />
                );
              })}
            </SoftBox>
          </TimelineList>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalHistorial.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  pedido: PropTypes.object,
};
